import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/generateVideo.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 22 24",
	...n,
	children: [
		/* @__PURE__ */ e("g", {
			clipPath: "url(#clip0_27462_33608)",
			children: /* @__PURE__ */ e("path", {
				fill: "#f2f2f3",
				d: "M16.29 9.57a.62.62 0 0 1-.582-.398l-.993-2.582a.4.4 0 0 0-.229-.229l-2.582-.993a.624.624 0 0 1 0-1.164l2.582-.993a.4.4 0 0 0 .229-.229L15.708.4a.623.623 0 0 1 1.164 0l.992 2.582a.4.4 0 0 0 .23.229l2.566.987a.635.635 0 0 1 .415.6.62.62 0 0 1-.399.57l-2.582.992a.4.4 0 0 0-.229.23l-.993 2.582a.62.62 0 0 1-.582.399"
			})
		}),
		/* @__PURE__ */ e("g", {
			clipPath: "url(#clip1_27462_33608)",
			children: /* @__PURE__ */ e("path", {
				fill: "#f2f2f3",
				d: "M8.795 3.252a4 4 0 0 0-.32 1.286l-.012.3.012.297a3.96 3.96 0 0 0 2.527 3.393h.003l1.36.525.52 1.352a3.96 3.96 0 0 0 1.46 1.855l.255.161a3.96 3.96 0 0 0 1.982.528l.018.002-.002-.002a3.96 3.96 0 0 0 2.224-.69A3.9 3.9 0 0 0 20 10.987v8.903a3.335 3.335 0 0 1-3.334 3.333H3.334A3.335 3.335 0 0 1 0 19.89V6.584a3.334 3.334 0 0 1 3.334-3.332zm-1.297 7.272a1.27 1.27 0 0 0-1.215 1.267v4.881a1.274 1.274 0 0 0 1.84 1.136l4.882-2.44a1.265 1.265 0 0 0 0-2.272l-4.882-2.44a1.3 1.3 0 0 0-.625-.133m9.437-1.012-.08.046q-.014.006-.029.01a.6.6 0 0 0 .111-.059zM11.86 4.564a1 1 0 0 1 .046-.08l.002-.002a1 1 0 0 0-.048.082"
			})
		}),
		/* @__PURE__ */ t("defs", { children: [/* @__PURE__ */ e("clipPath", {
			id: "clip0_27462_33608",
			children: /* @__PURE__ */ e("rect", {
				width: 9.57,
				height: 9.57,
				fill: "#fff",
				transform: "translate(11.504)"
			})
		}), /* @__PURE__ */ e("clipPath", {
			id: "clip1_27462_33608",
			children: /* @__PURE__ */ e("rect", {
				width: 20,
				height: 19.971,
				fill: "#fff",
				transform: "translate(0 3.252)"
			})
		})] })
	]
});
//#endregion
export { n as default };
